import type { Platform } from '../components/PlatformLogo';

export type AccountWorkspaceTab =
  | 'chat-assistant'
  | 'mass-messages'
  | 'priority-mass-messages'
  | 'automated-messages'
  | 'stats'
  /** Not an underline tab: the users button beside the settings gear opens it. */
  | 'access';

const ACCOUNT_WORKSPACE_TABS: readonly AccountWorkspaceTab[] = [
  'chat-assistant',
  'mass-messages',
  'priority-mass-messages',
  'automated-messages',
  'stats',
  'access',
];

function isWorkspaceTab(value: string): value is AccountWorkspaceTab {
  return (ACCOUNT_WORKSPACE_TABS as readonly string[]).includes(value);
}

/** Keep platform-specific availability in the shared account navigation. */
export function isAccountWorkspaceTabVisible(
  _platform: Platform,
  _tab: AccountWorkspaceTab,
  hasAccess: boolean,
): boolean {
  void _platform;
  void _tab;
  if (!hasAccess) return false;
  return true;
}

/** All accounts open on the shared assistant tab. */
export function defaultAccountWorkspaceTab(_platform: Platform): AccountWorkspaceTab {
  void _platform;
  return 'chat-assistant';
}

/** Drop removed or unavailable deep links instead of rendering a blank page. */
export function normalizeAccountWorkspaceTab(
  platform: Platform,
  activeTab: string,
): AccountWorkspaceTab {
  if (!isWorkspaceTab(activeTab)) return defaultAccountWorkspaceTab(platform);
  if (!isAccountWorkspaceTabVisible(platform, activeTab, true)) {
    return defaultAccountWorkspaceTab(platform);
  }
  return activeTab;
}
